import { ChangeEvent, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";
import { CheckoutInputFields, FieldState, InputTypes } from "@is/types";

type Props = {
  field: FieldState;
  onChange: (name: string, type: string, value: string) => void;
};

const useManageSignUpFormField = ({ field, onChange }: Props) => {
  const { t } = useTranslation(TranslationContext.General);

  const type = useMemo(
    () => (field.type === "phone" ? InputTypes.Tel : undefined),
    [field]
  );

  const handleTextInputChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { name, type, value } = event.target;

      onChange(name as CheckoutInputFields, type, value);
    },
    [onChange]
  );

  const handlePhoneInputChange = useCallback(
    (value: string) => {
      onChange(field.name, "text", value);
    },
    [field.name, onChange]
  );

  return {
    type,
    handleTextInputChange,
    handlePhoneInputChange,
    t,
  };
};

export default useManageSignUpFormField;
